import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Dots",
  "use": "svg-icon-Dots-usage",
  "viewBox": "0 0 16 4",
  "content": "<symbol viewBox=\"0 0 16 4\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Dots\"><path d=\"M14 0a2 2 0 1 1 .001 3.999A2 2 0 0 1 14 0zM8 0a2 2 0 1 1 .001 3.999A2 2 0 0 1 8 0zM2 0a2 2 0 1 1 .001 3.999A2 2 0 0 1 2 0z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol